import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {

  init({ state, dispatch }) {},

  createBenchmark(context, formData) {
    let promise = null
    promise =  axios.post(`${serverUrl}/APIv1/benchmarks/`, formData)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}